import(/* webpackMode: "eager" */ "/vercel/path0/app/faq/page.tsx")